var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEscapeLoad2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.194,
    height: 36.193,
    viewBox: "0 0 36.194 36.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21638",
    "data-name": "\\uADF8\\uB8F9 21638",
    transform: "translate(0.9 0.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10193",
    "data-name": "\\uD328\\uC2A4 10193",
    d: "M397.233,166.281a17.2,17.2,0,1,1-17.2-17.2A17.2,17.2,0,0,1,397.233,166.281Z",
    transform: "translate(-362.839 -149.084)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10194",
    "data-name": "\\uD328\\uC2A4 10194",
    d: "M367.5,165.2a12.139,12.139,0,0,1,24.278,0",
    transform: "translate(-362.438 -148.741)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_50",
    "data-name": "\\uC120 50",
    y2: 10.25,
    transform: "translate(17.199 4.321)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1213",
    "data-name": "\\uD0C0\\uC6D0 1213",
    cx: 3.035,
    cy: 3.035,
    r: 3.035,
    transform: "translate(14.418 14.752)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscapeLoad2);
export default __webpack_public_path__ + "static/media/EscapeLoad2.a5bea3f84022a0406ee162a6bca65c9a.svg";
export { ForwardRef as ReactComponent };